import { UserType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';
import type { IToolUserTypeDictionaryItem } from '@/types/dictionary';

export const toolUserTypeDictionary = createSimpleDictionary<IToolUserTypeDictionaryItem>(
    [
        { id: UserType.Root, name: 'dictionaries.toolUserType.root', code: 'RT', isActive: 1 },
        { id: UserType.Admin, name: 'dictionaries.toolUserType.administrator', code: 'AD', isActive: 1 },
        { id: UserType.Company, name: 'dictionaries.toolUserType.company', code: 'CO', isActive: 1 },
        { id: UserType.Agent, name: 'dictionaries.toolUserType.agent', code: 'AG', isActive: 1 },
        { id: UserType.AgentView, name: 'dictionaries.toolUserType.agentView', code: 'AW', isActive: 1 },
        { id: UserType.AgentPlatform, name: 'dictionaries.toolUserType.agentPlatform', code: 'AP', isActive: 1 },
        { id: UserType.Player, name: 'dictionaries.toolUserType.player', code: 'PL', isActive: 1 },
    ],
    ['name']
);
